module.exports = {
	"INLINE": "Teste",
	"nav_home": "Início",
	"nav_menu": "Menu",
	"nav_about": "Restaurante",
	"nav_wines": "Vinhos",
	"nav_suggestions": "Sugestões",
	"nav_events": "Eventos",
	"nav-feedback": "A sua opinião",
	"nav-pickly": "Sobre a Pickly",
	"follow_text": "Siga-nos",
	"desktop_languages": "Idiomas",
	"intro_default_option": "Filtrar ementa por:",
	"suggested_extras": "Acompanhamentos sugeridos",
	"suggested_wines": "Vinhos sugeridos",
	"cta_title": "Veja a nossa selecção de ",
	"cta_btn": "Ver",
	"related_products": "Produtos Similares",
	"error_home_link": "Voltar ao início",
	"error_home_title1": "Hmm...",
	"error_home_title2": "Não foi possível encontrar a página que procura.",
	"error_home_text": "Experimente reescrever o endereço ou tente de novo mais tarde.",
	"detail_title": "em detalhe",
	"list_event_title": "Eventos",
	"event_link": "Página oficial",
	"other_events": "Outros eventos",
	"filters": "Filtros",
	"filter-group-region-type": "Tipo de Vinho e Região",
	"region_default_option": "Escolha uma região",
	"filter-group-type": "Tipo",
	"type_default_option": "Escolha um tipo",
	"filter-group-flavour": "Sabor",
	"filter-group-characteristics": "Características do vinho",
	"sweetness_default_option": "Acidez",
	"filter-group-body": "Corpo",
	"body_default_option": "Escolha o corpo",
	"filter-group-ingredients": "Ingredientes Principais",
	"filter-group-diets": "Intolerâncias",
	"filter-results": "{results} resultados",
	"filter-clear-button": "Limpar Filtros",
	"filter-apply-button": "Aplicar",
	"related_dishes": "Pratos Sugeridos",
	"empty-title": "Sem resultados",
	"empty-text": "De momento não temos resultados para lhe apresentar, por favor tente novamente com novos parâmetros.",
	"feedback-title": "Ajude-nos a melhorar",
	"feedback-intro": "Pedimos-lhe que por favor responda a este pequeno questionário de avaliação, onde poderá expôr as suas opiniões e críticas.",
	"feedback-improve": "A Pickly melhorou a sua experiência no restaurante?",
	"feedback-error": "Por favor escolha uma opção",
	"feedback-harder": "Complicou",
	"feedback-no-help": "Não ajudou",
	"feedback-indiferent": "Indiferente",
	"feedback-helped": "Ajudou",
	"feedback-helped-a-lot": "Ajudou Bastante",
	"feedback-recommend": "Recomendaria a Pickly a outros restaurantes?",
	"feedback-no-recommend": "Não Recomendo",
	"feedback-recommend-neutral": "Indiferente",
	"feedback-recommend-yes": "Recomendo",
	"feedback-msg": "Gostaria de deixar alguma sugestão ou crítica para melhor a aplicação e/ou o serviço da Pickly? (opcional)",
	"feedback-submit": "Enviar",
	"feedback-thanks-title": "Obrigado",
	"feedback-thanks-text": "Obrigado por nos ajudar a melhorar! Pode voltar ao início através do botão abaixo.",
	"restaurant-feedback-title": "A sua opinião é importante.",
	"restaurant-feedback-subtitle": "Ajude-nos a melhorar.",
	"restaurant-feedback-intro": "Conte-nos como foi a sua experiência no nosso restaurante, avaliando o serviço, a comida e o ambiente, através de um breve questionário.",
	"restaurant-feedback-intro-btn": "Dar Feedback",
	"food-feedback-title": "Avaliação da COMIDA",
	"food-feedback-intro": "Dê a sua opinião e ajude-nos a melhorar.",
	"choice-question": "O menu tinha uma boa seleção de pratos",
	"presentation-question": "Os pratos tinham uma boa apresentação",
	"tasty-question": "A comida era saborosa e bem confeccionada",
	"service-feedback-title": "Avaliação do SERVIÇO",
	"speed-question": "Foram rápidos a tratar o nosso pedido",
	"waiters-question": "Os empregados foram simpáticos e atenciosos",
	"overall-question": "Em geral, o serviço foi bom",
	"global-feedback-title": "Avaliação GLOBAL",
	"deco-question": "O restaurante tinha um bom ambiente e decoração",
	"price-question": "A relação preço/qualidade foi boa",
	"recommend-question": "Recomendaria o restaurante a um amigo",
	"comments-question": "Comentários e sugestões",
	"recommend_title": "Recomendaria este prato?",
	"recommend_title_drink": "Recomendaria esta bebida?",
	"recommend-total": "{total} clientes recomendam este prato.",
	"recommend-total_drink": "{total} clientes recomendam esta bebida.",
	"type": "tipo",
	"body": "corpo",
	"region": "região",
	"accidity": "acidez",
	"mypick-text": "Com o myPick seleciona os pratos, bebidas e sobremesas preferidos para esta refeição. Depois, é só pedir ao empregado de mesa.",
	"cookie-notice": "Ao utilizar este site estará a consentir a utilização de cookies para análise e estatística.",
	"cookie-link": "Saiba mais",
	"terms-title": "Termos e condições",
	"cookies-title": "Política de cookies",
	"drinks-link-all": "Ver todos",
	"toggle_list": "Lista",
	"toggle_cards": "Cartas",
	"price_under_request": "Preço sob consulta"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/pt-pt.json
 ** module id = 279
 ** module chunks = 0
 **/